// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1bdSS","title":"Header_title__5xe2c","left":"Header_left__3Akzq","clinicName":"Header_clinicName__1BmKt"};